'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import type { Cookie, Treasurer } from '@personly/libs-types';
const toDomains = (cookie: Cookie) => {
  if (cookie.groupHandle === 'HOST') {
    return Object.keys(cookie.domains).reduce((acc: string[], host) => {
      const i = acc.findIndex(e => e === host);
      if (i === -1) return [...acc, host];
      return acc;
    }, []);
  } else if (cookie.groupHandle === 'DOMAIN') {
    return Object.keys(cookie.domains).reduce((acc: string[], host) => {
      const value = cookie.domains[host];
      const i = acc.findIndex(e => e === value);
      if (i === -1) return [...acc, value];
      return acc;
    }, []);
  }
  return [];
};
interface Props {
  cookie: Cookie;
  treasurer: Treasurer;
}
const CookieService = t0 => {
  const $ = _c(9);
  const {
    cookie,
    treasurer
  } = t0;
  let t1;
  if ($[0] !== cookie.service || $[1] !== cookie.url || $[2] !== treasurer.name) {
    t1 = cookie.service !== treasurer.name && <div className="font-bold underline text-center"><Link href={cookie.url}>{cookie.service}</Link></div>;
    $[0] = cookie.service;
    $[1] = cookie.url;
    $[2] = treasurer.name;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== cookie) {
    t2 = toDomains(cookie).map(_temp);
    $[4] = cookie;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex flex-col text-center p-0 md:py-2">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default CookieService;
function _temp(domain) {
  return <div key={domain}>{domain}</div>;
}